export const INFO_SET = 'info_set';
export const INFO_LOADED = 'info_loaded';
export const INFO_GET_ERROR = 'info_get_error';
export const INFO_REFRESH = 'info_refresh';
